<cass-core-toolbar></cass-core-toolbar>
<div class="register-container">
	<h1>{{ "USERS.CREATE_ACCOUNT.PAGE_TITLE" | translate }}</h1>
	<mat-card>
		<mat-card-content>
			<div class="centered-content">
				<div class='branding--register--action-card-image branding--register--account-image'></div>
			</div>

			<!--<img mat-card-image src='branding/home-account.png'/>-->
			<form [formGroup]="registerCustomerForm">
				<cass-contact-details [parentForm]="registerCustomerForm" [allowIntrinsicAccountCreation]="false" [showCountry]="false"></cass-contact-details>
			</form>
			<p>
				<button mat-raised-button color='primary' [disabled]="callingOut$ | async" (click)='createAccount()'>
					{{ "USERS.CREATE_ACCOUNT.ACTION_CREATE_ACCOUNT" | translate }}
				</button>
			</p>
			<p>
				{{ "USERS.CREATE_ACCOUNT.ALREADY_HAVE_AN_ACCOUNT_LABEL" | translate }}&nbsp;<a href='/login'>{{ "HOME.YOUR_ACCOUNT_CARD_ACTION_LOGIN" | translate }}</a>
			</p>
		</mat-card-content>
	</mat-card>
</div>

